import { AnalyzerMode } from '../../analyzers/types';
import { SnapshotHistoryRow } from '../types';
import { parseISO, isBefore } from 'date-fns';

export const getRecordingStatus = (
  row: SnapshotHistoryRow
):
  | 'None'
  | 'Live Continuous'
  | 'Live Interval'
  | 'Polling Continuous'
  | 'Live On Alarm'
  | 'Polling On Alarm' => {
  const now = new Date();
  const continuousModeStopTime = parseISO(
    row.historySettings?.continuous_mode_end_time
  );

  if (!row.historySettings) return 'None';
  if (
    row.analyzerActiveSnapshotId === row.id &&
    row.analyzerMode === AnalyzerMode.LIVE
  ) {
    if (
      row.historySettings.continuous_mode &&
      isBefore(now, continuousModeStopTime)
    )
      return 'Live Continuous';
    if (row.historySettings.interval_mode) return 'Live Interval';
    if (row.historySettings.interference_mode) return 'Live On Alarm';
  }
  if (row.analyzerMode === AnalyzerMode.POLLING) {
    if (!row.enabled) return 'None';
    if (!!row.historySettings.polling_continuous_mode && row.enabled)
      return 'Polling Continuous';
    if (row.historySettings.polling_interference_mode)
      return 'Polling On Alarm';
  }
  return 'None';
};
